import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { Observable } from 'rxjs';
import { EncryptionService } from '../../encryption/encryption.service';
import { Constants } from '../../common/reusableclassesAndFunctions/constants';
import { ReusableClasses } from '../../common/reusableclassesAndFunctions/reusable-classes';
import {tap} from 'rxjs/operators';
import { CommonService } from '../../common/common.service';
import * as jwt_decode from 'jwt-decode';
//import { Observable } from "rxjs/Observable";
@Injectable()
export class Interceptor implements HttpInterceptor {

    /**
     *
     */

    refreshTokenresponseHolder: any;
    permissionsAssigned: any[] = [];
    loginToken: any;
    decodedUserData: any;
    organizationID: any;
    databaseID: any;  

    constructor(private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
        private commonService: CommonService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (sessionStorage.getItem('userToken') != null) {
            const encryptedtoken = sessionStorage.getItem('userToken');
            const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
            let newHeaders = request.headers;
            if (token) {
                newHeaders = newHeaders.append('Authorization','Bearer ' + token);
               // newHeaders = newHeaders.append('Content-Encoding','gzip');
            }
            const authReq = request.clone({ headers: newHeaders });
            // return next.handle(authReq);

            return next.handle(authReq).pipe( tap(() => {},
            (err: any) => {
            if (err instanceof HttpErrorResponse) {
              if (err.status !== 401) {
               return;
              }
              else{
                this.commonService.refreshToken().subscribe(response=>{
                    if (response != undefined) {
                        this.refreshTokenresponseHolder = response;
                        this.loginToken = this.refreshTokenresponseHolder.data.jwttoken;
                        sessionStorage.setItem('refreshToken', this.refreshTokenresponseHolder.data.refreshtoken);                        
                        this.decodedUserData = jwt_decode(this.loginToken);
                        this.databaseID = sessionStorage.getItem('databaseId')?? '';
                        this.organizationID = sessionStorage.getItem('organizationID')?? '';
                        var permissions = sessionStorage.getItem('permissions');                        
                        
                        this.commonService.setLoggedInUserDetailsSession(this.decodedUserData, this.loginToken,permissions, this.databaseID, this.organizationID);

                        //this.commonService.setLoggedInUserDetails(this.decodedUserData, this.loginToken, this.permissionsAssigned, '', '');
                        window.location.reload();
                    }
                });
              }
              
            }
          }));
      

        }

        return next.handle(request).pipe();


    }
}
